import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IconButton, useScrollTrigger, AppBar, useMediaQuery } from 'lib/@mui';
import { Menu as MenuIcon } from 'lib/@mui/Icons';
import classNames from 'classnames';

import HideOnScroll from './HideOnScroll';
import { hasNavigationBar } from 'containers/Ezlo/pageLayout/hasNavigationBar';
import { Visibility } from '../Visibility';
import { EmailVerificationBanner } from 'components/VerificationWarningBar';
import { DESKTOP_MEDIA_QUERY } from 'constants/common/breakpoints';

import * as Actions from '../../actions';

import styles from './Header.module.scss';
import { AppLogo } from '../../assets/icons';

const Header = (props) => {
    const { children, MainAction, threshold, headerClassName, disableHysteresis } = props;
    const hasNavigation = hasNavigationBar();
    const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);

    const isAppBarEmpty = typeof children === 'undefined';
    const trigger = useScrollTrigger({
        threshold: threshold,
        disableHysteresis: disableHysteresis,
    });

    return (
        <>
            <HideOnScroll {...props}>
                <AppBar
                    className={classNames(styles.header, {
                        header_active: trigger,
                        header_empty: isAppBarEmpty,
                        [styles.full_width]: !hasNavigation,
                    })}
                >
                    <div className={styles.headerBox}>
                        {(!isAppBarEmpty || !isDesktop) && (
                            <div className={classNames(styles.headerContent, headerClassName)}>
                                <div className={styles.tabletLogo}>
                                    <Visibility visible={hasNavigation}>
                                        <IconButton onClick={MainAction.showNavigation}>
                                            <MenuIcon />
                                        </IconButton>
                                    </Visibility>
                                    <AppLogo isHeader={true} />
                                </div>
                                {children}
                            </div>
                        )}
                        <EmailVerificationBanner />
                    </div>
                </AppBar>
            </HideOnScroll>
        </>
    );
};

const mapStateToProps = (state) => ({
    isShowNavigation: state.main.isShowNavigation,
});

const mapDispatchToProps = (dispatch) => ({
    MainAction: bindActionCreators(Actions.MainAction, dispatch),
});

Header.defaultProps = {
    threshold: 0,
    disableHysteresis: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
